// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__v-ieU","footer":"ChangeClinic_footer__8R5n3"};